import axios from 'axios'
import apiConfig, { appEnv } from '../apiConfig'

const {
  projectsApi = '',
  packagingApi = '',
  apiKey = '',
  getUserCustomColumns = '',
  getWorkflowItemsApi = '',
  projectStatusApi = '',
  projectTcinStatusApi = '',
} = apiConfig

export function fetchProjectImages({
  projectId = '',
  page = 0,
  numberOfRows,
  searchText = [],
  searchBy = '',
}) {
  const projectUrl = `${projectsApi}/${projectId}`
  return axios.get(projectUrl, {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      key: apiKey,
      page: page,
      size: numberOfRows,
      search_term: searchText,
      search_by: searchBy,
    },
  })
}
export function getProjectStatus({ projectId = '' }) {
  const projectUrl = `${projectStatusApi}`
  return axios.get(projectUrl, {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      clientSystem: 'PHOTOBRIDGE',
      projectId: projectId,
      key: apiKey,
    },
  })
}

export function getProjectTCINStatus({
  projectId = '',
  page = 0,
  numberOfRows,
}) {
  const projectUrl = `${projectTcinStatusApi}`
  return axios.get(projectUrl, {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      clientSystem: 'PHOTOBRIDGE',
      projectId: projectId,
      key: apiKey,
      page: page,
      size: numberOfRows,
    },
  })
}

export function fetchProjectPackagingImages({
  projectId = '',
  page = 0,
  numberOfRows,
  searchText = [],
  searchBy = '',
}) {
  let paramsList = {
    key: apiKey,
    page: page,
    size: numberOfRows,
  }
  if (searchText?.length) {
    paramsList = Object.assign({}, paramsList, {
      search_term: searchText,
      search_by: searchBy,
    })
  }
  const projectUrl = `${packagingApi}/fetch_packaging_assets?projectId=${projectId}`
  return axios.get(projectUrl, {
    headers: {
      'Content-Type': 'application/json',
    },
    params: paramsList,
  })
}

export function fetchAdditionalAssets({
  projectId = '',
  page = 0,
  numberOfRows,
  searchText = [],
  searchBy = '',
}) {
  let paramsList = {
    key: apiKey,
    page: page,
    size: numberOfRows,
  }
  if (searchText?.length) {
    paramsList = Object.assign({}, paramsList, {
      search_term: searchText,
      search_by: searchBy,
    })
  }
  const projectUrl = `${packagingApi}/fetch_additional_assets?projectId=${projectId}`
  return axios.get(projectUrl, {
    headers: {
      'Content-Type': 'application/json',
    },
    params: paramsList,
  })
}

export function repurposeAHImages({ params = {}, lanId = '' }) {
  const repurposeAssetsUrl = `${packagingApi}/repurpose_assets`
  return axios.post(
    repurposeAssetsUrl,
    {
      ...params,
    },
    {
      headers: {
        'x-tgt-lanid': lanId,
      },
      params: {
        key: apiKey,
      },
    }
  )
}

export function fetchCustomColumnsList({ userId = '' }) {
  const customColumnsUrl = `${getUserCustomColumns}?user_id=${userId?.toUpperCase()}&view=project`
  return axios.get(customColumnsUrl, {
    params: {
      key: apiKey,
    },
  })
}

export function updateCustomColumnsList({ userId = '', columnList = [] }) {
  const customColumnsUrl = `${getUserCustomColumns}?view=project`
  const params = {
    user_id: userId.toUpperCase(),
    column_list: columnList,
  }
  return axios.post(
    customColumnsUrl,
    {
      ...params,
    },
    {
      params: {
        key: apiKey,
      },
    }
  )
}

export function makeProjectsArchive({ params = {} }) {
  const projectArchiveUrl = `${projectsApi}/archives`
  return axios.post(
    projectArchiveUrl,
    {
      ...params,
    },
    {
      params: {
        key: apiKey,
      },
    }
  )
}

export function removeTcinsFromProjectService({
  data = {},
  projectId = '',
  lanId = '',
}) {
  let url = `${projectsApi}/update_tcins`
  return axios.post(url, data, {
    params: {
      key: apiConfig.apiKey,
      project_id: projectId,
    },
    headers: {
      ...(appEnv === 'dev' && { 'x-tgt-lanId': lanId }),
    },
  })
}

export function updateProjectService({
  projectId = '',
  requestBody = {},
  accessToken = '',
  lanId = '',
}) {
  const updateProjectUrl = `${projectsApi}/${projectId}`
  return axios.put(updateProjectUrl, requestBody, {
    params: {
      key: apiConfig.apiKey,
    },
  })
}

export function setProjectArchiveService({ body = {} }) {
  const url = `${projectsApi}/archive`
  return axios.post(url, body, {
    params: {
      key: apiConfig.apiKey,
    },
  })
}

export function getAllProjectService({
  page = 0,
  rowsPerPage = 10,
  isMyProjects = false,
  isIncludedArchived = false,
  searchTerm = '',
  searchQuery = '',
  company = '',
  userId = '',
  lanId = '',
  orderBy = 'created_date',
  order = 'desc',
}) {
  const url = `${projectsApi}`
  return axios.get(url, {
    params: {
      key: apiConfig.apiKey,
      archived: isIncludedArchived,
      is_user_projects: isMyProjects,
      company: company || null,
      page: page,
      size: rowsPerPage,
      search_by: searchTerm,
      search_term: searchQuery,
      sort_by: orderBy,
      sort_order: order,
    },
    headers: {
      ...(appEnv === 'dev' && { 'x-tgt-lanId': userId || lanId }),
    },
  })
}

export function getWorkflowItemsData({ filters = {} }) {
  return axios.post(
    getWorkflowItemsApi,
    {
      phase: 'SEARCH',
      filters: filters,
    },
    {
      params: {
        key: apiConfig.apiKey,
      },
    }
  )
}
